import { UserWithToken } from 'interfaces/user';
import { NoAuthService } from './service';
import Store from '../redux/configureStore';
import { getAirshipChannelId } from '../utils/airshipHandler';
import { DeviceInformationPayloadV2 } from './airship.service';
import { DeviceInformationMapping, getLanguageFromLocalStorage } from '../i18n';

const Config = require('Config');

type LoginReturn = {
  email: string;
  token: string;
};

type ResponseError = {
  response: { status: number };
};
export class V2LoginService extends NoAuthService {
  constructor() {
    const { sessionServiceUrl } = Config;
    super(`${sessionServiceUrl}v2/session/login`);
  }
  public async login(username: string, password: string, verificationCode: string): Promise<LoginReturn> {
    const airshipChannelId = await getAirshipChannelId();
    const cpua5206 = Store.getState().app.features.includes('CPUA-5206');
    const deviceId = Store.getState().app.deviceId;
    const localLanguage = getLanguageFromLocalStorage();
    const deviceInformationPayload = cpua5206 ? {
      deviceInformation: {
        email: username,
        device_id: deviceId,
        action: "create",
        attributes: [{
          action: "set",
          key: "rtspro_selected_language",
          value: DeviceInformationMapping[localLanguage] ?? 'english'
        }],
        deviceType: "web"
      } as DeviceInformationPayloadV2
    } : {};

    const {
      data: { email, token, roles, status, company_id },
    } = await this.axios.request<UserWithToken>({
      method: 'post',
      data: {
        username,
        password,
        verificationCode,
        ...(airshipChannelId ? { airshipChannelId } : {}),
        ...deviceInformationPayload,
      },
    });

    if (!roles?.length && status === 'inactive' && company_id !== null) {
      const inactiveUserError: ResponseError = { response: { status: 403 } };
      throw inactiveUserError;
    }
    return { email, token };
  }

  public async sendVerificationCode(email: string, verificationType?: string) {
    try {
      const response = await this.axios.request({
        method: 'GET',
        url: email,
        params: {
          verificationType,
        },
      });
      if (response.status !== 200) {
        throw new Error('Something went wrong');
      }
      return response;
    } catch (e) {
      if (e.response?.status === 429) {
        return { error: 'You can try again in 1 minute.' };
      }
      return { error: 'Failed to send verification code. Please try again later.' };
    }
  }
}
